module.exports = __webpack_public_path__ + "static/media/leftmenuimage.c6c284c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leftmenuimage.png
// module id = 139
// module chunks = 0